// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1KK1h","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1rNps"};